<div class="credits-container">
  <p class="title">Standard Credits Price</p>
  <mat-form-field class="credits-field">
    <mat-label>Price</mat-label>
    <input
      matInput
      placeholder="Enter price"
      [disabled]="!editMode"
      [ngModel]="price"
      (ngModelChange)="onPriceChange($event)"
      name="price"
      id="price"
      type="number"
      [min]="MIN_PRICE"
      [max]="MAX_PRICE"
      step="1" />
    @if (!hasError && editMode) {
      <mat-hint>
        Enter a value between {{ MIN_PRICE }} and {{ MAX_PRICE }}
      </mat-hint>
    }
    @if (hasError) {
      <mat-error>{{ errorMessage }}</mat-error>
    }
  </mat-form-field>
</div>
